import { Col, Row } from "react-bootstrap";
import KrrDataView from "./KrrDataView";
import { useUserProfile } from "../../Contexts/UserProfile";
import { BootstrapSpinner } from "../../common/spinners/bootstrapSpinner";
import { useProfileConfig } from "../../common/config/configHooks";

const UserProfilePage = () => {
  const userProfileService = useProfileConfig();

  const userProfile = useUserProfile();

  return (
    <>
      <div className="container profile-container">
        <Row>
          <Col xs={{ span: 12 }}>
            <section>
              <h1>Min profil</h1>
              {userProfileService?.hideService ? (
                "Tjenesten er dessverre ikke tilgjengelig."
              ) : (
                <>
                  {userProfileService?.alertText &&
                    userProfileService?.alertText !== "" && (
                      <div className="infoBoxLanding">
                        <p>{userProfileService?.alertText}</p>
                      </div>
                    )}
                  <p>{userProfileService?.ingressText}</p>
                  {userProfile ? (
                    userProfile ? (
                      <KrrDataView
                        profile={userProfile.krrData}
                        profileService={userProfileService}
                      />
                    ) : (
                      <p>{userProfileService?.notFoundText}</p>
                    )
                  ) : (
                    <>
                      <BootstrapSpinner />
                    </>
                  )}
                </>
              )}
            </section>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default UserProfilePage;
